export default __webpack_public_path__ + "963adf25cc11693fbb7d3384ba1f1f99.svg";